export default {
  giftCard: 'gift_card',
  credit: 'credit'
};
